import { useHasPermission } from '../../Permissions/hooks/useHasPermission';

export const useCanDeletePrompt = (territoryId?: string): boolean => {
  const hasPermission = useHasPermission();

  return (
    hasPermission('GLOBAL_CAN_DELETE_ARTICLE') ||
    hasPermission('GLOBAL_CAN_DELETE_OWN_ARTICLE') ||
    (!!territoryId &&
      (hasPermission('TERRITORY_CAN_DELETE_ARTICLE', territoryId) ||
        hasPermission('TERRITORY_CAN_DELETE_OWN_ARTICLE', territoryId)))
  );
};
